export const CommonCertificatesAnprCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Gestione Certificati Postazione Anpr',
    path: '/sistema/certificati-postazione',
  },
];
